export const FORM_NAME = 'CommercialLeaseBasics';
export const EDIT_LEASE_SCOPE = ['lease-current-lease-end-date-edit'];
export const EDIT_FORM_NAME = 'EditCommercialLeaseBasics';
